import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import IconClose from 'components/icons/iconClose';
import IconArrowRight from 'components/icons/iconArrowRight';
import ShowroomLocatorResults from 'components/consumer/consumer-new-footer/components/ShowroomLocatorResults';
import useShowroomLocator, { validateZipcodeInput } from 'hooks/useShowroomLocator';
const MobileNavbarShowroomLocator = t0 => {
  const $ = _c(22);
  const {
    onClose
  } = t0;
  const {
    stores,
    loading,
    error,
    hasSearched,
    handleSearch,
    handleCloseResults,
    handleViewAll
  } = useShowroomLocator();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-gray font-bold text-base">Find your closest showroom</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = onClose && <button type="button" onClick={onClose} className="text-gray p-1" aria-label="Close"><IconClose width={12} height={12} /></button>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="flex justify-between items-center mb-2">{t1}{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      zipcode: ""
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleSearch) {
    t5 = <Formik initialValues={t4} validate={validateZipcodeInput} onSubmit={t6 => {
      const {
        zipcode
      } = t6;
      handleSearch(zipcode);
    }}>{_temp}</Formik>;
    $[6] = handleSearch;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="text-xs text-gray font-normal my-2">Within 50 miles</div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== error || $[10] !== handleCloseResults || $[11] !== hasSearched || $[12] !== loading || $[13] !== stores) {
    t7 = hasSearched && <ShowroomLocatorResults loading={loading} error={error} stores={stores} onClose={handleCloseResults} isMobile={true} />;
    $[9] = error;
    $[10] = handleCloseResults;
    $[11] = hasSearched;
    $[12] = loading;
    $[13] = stores;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== handleViewAll) {
    t8 = <div className="mt-3"><Link to="/showrooms/" onClick={handleViewAll} className="text-brand underline text-sm !font-semibold">View All</Link></div>;
    $[15] = handleViewAll;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t5 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className="w-[280px] px-4 py-3 font-bold [&_a]:!text-brand [&_a]:!underline">{t3}{t5}{t6}{t7}{t8}</div>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
MobileNavbarShowroomLocator.propTypes = {
  onClose: PropTypes.func
};
export default MobileNavbarShowroomLocator;
function _temp(t0) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit
  } = t0;
  return <form onSubmit={handleSubmit}><div className="flex items-stretch"><input id="mobile-navbar-showroom-zipcode" name="zipcode" type="text" placeholder="Zip Code" value={values.zipcode} onChange={handleChange} onBlur={handleBlur} maxLength="5" autoComplete="postal-code" className="flex-1 border border-gray-light5 px-3 py-2 text-sm outline-none focus:border-brand" /><button type="submit" className="bg-brand text-white px-3 flex items-center justify-center [&_path]:fill-white" aria-label="Search"><IconArrowRight width={16} height={10} /></button></div>{touched.zipcode && errors.zipcode && <div className="text-red text-xs mt-1">{errors.zipcode}</div>}</form>;
}